<h2 mat-dialog-title>{{ 'AI_ASSISTANT.GOALS.ADD_GOAL.ADD_A_CAPABILITY' | translate }}</h2>
<mat-dialog-content>
  <div class="goals-list">
    @if (!(isLoading() && goals().length === 0)) {
      <mat-card class="add-button capability-card" (click)="newGoal()">
        <mat-card-content>
          <mat-icon class="capability-icon">auto_awesome</mat-icon>
          <div class="new-capability-title">{{ 'AI_ASSISTANT.GOALS.ADD_GOAL.NEW_CAPABILITY' | translate }}</div>
        </mat-card-content>
      </mat-card>
    }
    @for (goal of goals(); track goal.id) {
      <mat-card (click)="chooseGoal(goal)" class="clickable-card capability-card">
        <mat-card-content>
          <mat-icon class="capability-icon">auto_awesome</mat-icon>
          <div class="goal-name">
            {{ goal.name }}
          </div>
          <div>
            {{ goal.description }}
          </div>
          <div class="functions">
            @for (goalFunction of goal.functions; track goalFunction.id) {
              <glxy-badge color="blue" size="small">{{ goalFunction.id }}</glxy-badge>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>
  @if (isLoading()) {
    <glxy-loading-spinner></glxy-loading-spinner>
  }
  <glxy-infinite-scroll-trigger (isVisible)="loadGoals()" />
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
</mat-dialog-actions>
